export default {
  getHref() {
    return window.location.href
  }
}
